import _ from 'lodash'
import { getBuilderComponentsData, getPathToSelectorMap } from '@wix/thunderbolt-commons'
import type { FetchFn, IManifestPublicElement, PathToSelector, ViewerClientSpecMap } from '@wix/thunderbolt-symbols'
import type { Logger, Structure } from '@wix/thunderbolt-becky-types'

export const getCompIdToPathToSelector = async (
	structure: Structure,
	clientSpecMap: ViewerClientSpecMap,
	fetchFn: FetchFn,
	logger: Logger
): Promise<Record<string, PathToSelector>> => {
	const compIdToBuilderType: Record<string, string> = _.reduce(
		structure,
		(acc, { id, builderType }) => {
			if (builderType) {
				acc[id] = builderType
			}
			return acc
		},
		{} as Record<string, string>
	)

	const builderComponentsManifestUrls: Record<string, string> = _.mapValues(
		getBuilderComponentsData(clientSpecMap),
		({ viewerReducedModel }) => viewerReducedModel
	)

	const builderComponentsManifests: Record<string, IManifestPublicElement> = Object.fromEntries(
		await Promise.all(
			Object.entries(builderComponentsManifestUrls).map(([builderType, url]) =>
				fetchFn(url)
					.then((response) => response.json())
					.then((manifest: IManifestPublicElement) => [builderType, manifest])
					.catch((error) => {
						logger.error(`Failed to fetch manifest for builderType: ${builderType} from ${url}`, error)
						return [builderType, undefined]
					})
			)
		)
	)

	const compIdToManifest = _.pickBy(
		_.mapValues(compIdToBuilderType, (builderType) => builderComponentsManifests[builderType]),
		(manifest) => manifest
	)

	return _.mapValues(compIdToManifest, ({ elementsData }, id) => getPathToSelectorMap(id, elementsData))
}
